module.exports = __webpack_public_path__ + "img/feder.bd2b1374.jpg";